import { View } from 'react-native'

import { styled } from '~/core/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      minWidth: theme.sizingExtrasmall * theme.sizingTiny,
      maxWidth: theme.sizingHuge * theme.sizingMini,
      backgroundColor: theme.colorFillNeutralDefault,
      borderWidth: theme.sizingNone,
      borderColor: theme.colorNone,
      borderRadius: theme.borderWidthNone,
      flexDirection: 'column',
      padding: theme.fontSizeFourpulse,
      gap: theme.spacingStackThreepulse,
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
  }
})

export const Header = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      width: '100%',
      gap: theme.spacingInlineThreepulse,
      alignItems: 'center',
    },
  }
})

export const HeaderContent = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      gap: theme.spacingInlineThreepulse,
      flex: 1,
      alignItems: 'flex-start',
    },
  }
})

export const Info = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      width: '100%',
      gap: theme.spacingInlineThreepulse,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }
})

export const InfoContent = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      gap: theme.spacingInlineOnepulse,
      flex: 2,
    },
  }
})

export const ButtonsContainer = styled(View, theme => {
  return {
    base: {
      flex: 1,
      flexDirection: 'row',
      gap: theme.spacingInlineThreepulse,
      marginLeft: theme.spacingInlineTwopulse,
    },
  }
})
